<template>
  <GenericLayout :title="$t('PRIVACY_POLICY')" class="fill-height">
    <PrivacyPolicyEs v-if="$i18n.locale === 'es'" />
    <PrivacyPolicyEn v-else />
  </GenericLayout>
</template>

<style scoped>
>>> .container {
  max-width: 800px;
  margin: 0 auto;
}

>>> h1 {
  text-align: center;
  margin: 16px 0 32px;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';

import PrivacyPolicyEs from '@/views/legal/PrivacyPolicyEs.vue';
import PrivacyPolicyEn from '@/views/legal/PrivacyPolicyEn.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    GenericLayout,
    PrivacyPolicyEs,
    PrivacyPolicyEn,
  },
};
</script>
